import React, { useEffect, useState } from 'react';
import css from './AboutSignorVineyards.module.css';
import { types as sdkTypes } from '../../../util/sdkLoader';
import {
  StarFilledIcon,
  StarIcon,
  GlobeIcon,
  CallIcon,
  AddessIcon,
  CalenderIcon,
  ClockIcon,
  HappyFaceIcon,
  MessageIcon,
  HeartIcon,
  FilledHeartIcon,
  Ellipse,
  FacebookIcon,
  InstgramIcon,
  TiwtterIcon,
  YoutubeIcon,
  TiktokIcon,
} from '../../../assets';
import { ExternalLink, InlineTextButton, NamedLink } from '../../../components';
import MapGL from '../../../components/Map/MapGL';
import { makeFavorite } from '../../../services/favorite';
import { toast } from 'react-toastify';
import ReactHtmlParser from 'react-html-parser';
import MboxMap from '../../../components/Map/MboxMap';
import { BiMap } from 'react-icons/bi';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

const { LatLng } = sdkTypes;

function AboutSignorVineyards({ winery, locations, currentUser, setIsMyFav, isMyFav }) {
  const [makeFavoriteLoading, setMakeFavoriteLoading] = useState(false);
  const [messaging, setMessaging] = useState(null);
  const [togHour, setTogHour] = useState(false);
  const [togAddr, setTogAddr] = useState(false);
  const [togMap, setTogMap] = useState(false);
  const [hours, setHours] = useState({
    mon: '',
    tue: '',
    wed: '',
    th: '',
    fri: '',
    sat: '',
    sun: '',
  });

  useEffect(() => {
    if (winery) {
      // set hours on mounted
      setHours({
        ...hours,
        mon: winery?.hours?.mon,
        tue: winery?.hours?.tue,
        wed: winery?.hours?.wed,
        th: winery?.hours?.th,
        fri: winery?.hours?.fri,
        sat: winery?.hours?.sat,
        sun: winery?.hours?.sun,
      });
    }
  }, [winery]);

  const handleAddToFavorite = () => {
    if (currentUser) {
      const obj = {
        wineryId: winery._id,
        userId: currentUser.expresUserId,
        sharetribeUserId: currentUser.id.uuid,
      };
      makeFavorite(obj, setMakeFavoriteLoading, setIsMyFav);
    } else {
      toast.info('Please login first to add this winery to your favorites');
    }
  };

  const condition = linkType => {
    return (
      winery?.socialLinks[linkType] === 'null' ||
      winery?.socialLinks[linkType] === '' ||
      winery?.socialLinks[linkType] === null
    );
  };

  const socialLinks = [
    {
      href: condition('facebook') ? undefined : winery?.socialLinks.facebook,
      Icon: FacebookIcon,
    },
    {
      href: condition('instagram') ? undefined : winery?.socialLinks.instagram,
      Icon: InstgramIcon,
    },
    {
      href: condition('twitter') ? undefined : winery?.socialLinks.twitter,
      Icon: TiwtterIcon,
    },
    {
      href: condition('youtube_or_vimeo_link')
        ? undefined
        : winery?.socialLinks.youtube_or_vimeo_link,
      Icon: YoutubeIcon,
    },
    {
      href: condition('tiktok') ? undefined : winery?.socialLinks.tiktok,
      Icon: TiktokIcon,
    },
  ];

  const wineryClaimContent = () => {
    switch (winery?.claimed) {
      case 'claim':
        return (
          <div className={css.box}>
            <StarIcon />
            <NamedLink name="ClaimPage" params={{ id: winery._id }}>
              <span>Claim Your Page</span>
            </NamedLink>
          </div>
        );
      case 'pending':
        return (
          <div className={css.box}>
            <StarIcon />
            <span>Your claim Request is pending</span>
          </div>
        );
      case 'claimed':
        return (
          <div className={css.box}>
            <StarFilledIcon />
            <span>Claimed Business</span>
          </div>
        );
      case 'rejected':
        return (
          <div className={css.box}>
            <StarIcon />
            <NamedLink name="ClaimPage" params={{ id: winery._id }}>
              <span>Claim Your Page</span>
            </NamedLink>
          </div>
        );
      default:
        break;
    }
  };
  return (
    <div className={css.AboutSignorVineWrapper}>
      <div className={css.AboutSignorVineEllipse}>
        <Ellipse />
      </div>
      <div className={css.AboutSignorVineContainer}>
        <div className={css.AboutSignorVineLeftside}>
          <div>
            <h1>About {winery.name}</h1>
            <p>{ReactHtmlParser(winery.description)}</p>
          </div>
          {/* <div>
            <h1>{winery?.name} Wine Club</h1>
            <h5>Choose Between 3, 6, or 12 Bottles</h5>
            <p>With each club, you will receive up to 5 shipments/ pickups of our limited-batch, barrel select wines to collect and savor. You will also enjoy exclusive member benefits as well as our trademark hospitality and VIP treatment at our winery.</p>
            <InlineTextButton rootClassName={css.AboutSignorVineLoadMoreBtn}>
              <NamedLink name="WineClubs">
                <span style={{color: "#FFF"}}>Learn More</span>
              </NamedLink>
            </InlineTextButton>
          </div> */}
        </div>

        <div className={css.AboutSignorVineRight}>
          {wineryClaimContent()}
          {winery?.website !== null ? (
            <div className={css.box}>
              <GlobeIcon />
              <a href={`https://${winery.website}`} target="_blank">
                <span>{winery.website}</span>
              </a>
            </div>
          ) : null}
          <div className={css.box}>
            <CallIcon />
            <span>{winery?.phone}</span>
          </div>
          {messaging !== null ? (
            <div id={css.message} className={css.box}>
              <MessageIcon />
              <span>Message The Business</span>
            </div>
          ) : null}
          {/* toggle map  */}
          <div style={{ marginBottom: '3px' }}>
            <div
              style={{ cursor: 'pointer', marginBottom: 0 }}
              className={css.box}
              onClick={() => setTogMap(!togMap)}
            >
              <div className={css.loc_icon}>
                <BiMap />
              </div>
              <span>Map</span>
              {togMap ? (
                <div style={{ marginLeft: 'calc(60% - 10px)', fontSize: '23px' }}>
                  <IoIosArrowUp style={{ color: `var(--burgundy)` }} />
                </div>
              ) : (
                <div style={{ marginLeft: 'calc(60% - 10px)', fontSize: '23px' }}>
                  <IoIosArrowDown style={{ color: `var(--burgundy)` }} />
                </div>
              )}
            </div>
            <div
              style={{
                display: togMap ? '' : 'none',
                width: '100%',
                height: '178px',
              }}
            >
              {/* <MapGL
              locations={locations}
              zoom={14}
              latitude={Number(winery.lat)}
              longitude={Number(winery.lng)}
            /> */}
              <MboxMap
                center={new LatLng(Number(winery?.lat), Number(winery?.lng))}
                zoom={14}
                locations={locations}
              />
            </div>
          </div>
          {/* toggle address */}
          <div style={{ marginBottom: '3px' }}>
            <div
              style={{ cursor: 'pointer', marginBottom: 0 }}
              className={css.box}
              onClick={() => setTogAddr(!togAddr)}
            >
              <AddessIcon />
              <span>Address</span>
              {togAddr ? (
                <div style={{ marginLeft: 'calc(60% - 28px)', fontSize: '23px' }}>
                  <IoIosArrowUp style={{ color: `var(--burgundy)` }} />
                </div>
              ) : (
                <div style={{ marginLeft: 'calc(60% - 28px)', fontSize: '23px' }}>
                  <IoIosArrowDown style={{ color: `var(--burgundy)` }} />
                </div>
              )}
            </div>

            <div
              style={{ display: togAddr ? 'flex' : 'none', marginBottom: 0 }}
              className={css.box}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>
                  {winery?.street}, {winery?.city}, {winery?.state}, {winery?.zip}
                </span>
                {/* <InlineTextButton rootClassName={css.getDirectionsBtn}> */}
                <ExternalLink
                  href={`https://www.google.com/maps/dir/?api=1&destination=${winery.name}+${winery.street}+${winery.city}+${winery.state}`}
                >
                  <span style={{ paddingTop: '8px', color: '#2B2F68' }}>Get Directions</span>
                </ExternalLink>
                {/* </InlineTextButton> */}
              </div>
            </div>
          </div>
          {/* toggle hours  */}
          <div style={{ marginBottom: '3px' }}>
            <div
              style={{ cursor: 'pointer', marginBottom: 0 }}
              className={css.box}
              onClick={() => setTogHour(!togHour)}
            >
              <ClockIcon />
              <span>Hours</span>
              {togHour ? (
                <div style={{ marginLeft: 'calc(60% - 15px)', fontSize: '23px' }}>
                  <IoIosArrowUp style={{ color: `var(--burgundy)` }} />
                </div>
              ) : (
                <div style={{ marginLeft: 'calc(60% - 15px)', fontSize: '23px' }}>
                  <IoIosArrowDown style={{ color: `var(--burgundy)` }} />
                </div>
              )}
            </div>
            <div
              style={{
                display:
                  (hours.fri ||
                    hours.sat ||
                    hours.sun ||
                    hours.mon ||
                    hours.tue ||
                    hours.wed ||
                    hours.th) &&
                  togHour
                    ? 'flex'
                    : 'none',
                marginBottom: 0,
              }}
              className={css.box}
            >
              <div>
                {hours &&
                  Object.keys(hours).map((h, index) => (
                    <div key={index}>
                      {hours[h] !== undefined ? (
                        <span style={{ textTransform: 'uppercase' }}>
                          {h.slice(0, 2)}: {hours[h]}
                        </span>
                      ) : null}
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {winery.searchMeta.cellarpass_url !== null ? (
            <div className={css.box}>
              <CalenderIcon />
              <ExternalLink href={winery.searchMeta.cellarpass_url}>
                <span>Make Reservation</span>
              </ExternalLink>
            </div>
          ) : null}
          {isMyFav ? (
            <div className={css.box}>
              <FilledHeartIcon />
              <span>favorited</span>
            </div>
          ) : (
            <div onClick={handleAddToFavorite} className={css.box}>
              <HeartIcon />
              <span style={{ cursor: 'pointer' }}>Add To Your Favorites</span>
            </div>
          )}

          <div className={css.box}>
            <HappyFaceIcon />
            <div style={{ marginLeft: '16px' }}>
              {socialLinks &&
                socialLinks.map((i, index) => (
                  <React.Fragment key={index}>
                    {i.href !== undefined ? (
                      <ExternalLink style={{ paddingRight: '12px' }} key={index} href={i.href}>
                        <i.Icon />
                      </ExternalLink>
                    ) : null}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutSignorVineyards;
